import React from "react";
import NavBar from "../Components/HomeSections/NavBar";
import Footer from "../Components/HomeSections/Footer";
import FilterHeader from "../Components/PropertyFilters/FilterHeader";
import "../Style/PropertyHeader/filterSearch.css";
import PropertyListingSection from "../Components/propertylisting/PropertyListingSection";
import NeedHelp from "./../Components/propertyDetails/NeedHelp";
import ListingSecondBanner from "../Components/propertylisting/ListingSecondBanner";

// Each section maps to an existing, working API endpoint.
// sale/lease/property/list keys: 1=For Sale, 2=For Lease, 4=Leased, 5=Sold, 6=Acquired, 7=Executive Leasing
// category/properties/list keys (category_id): 1=Residential Home Sales, 2=Residential Land Sales, 5=New Home for Sale, 6=Residential Rental Listing
const Propertylisting = () => {
  return (
    <>
      <div className="filterbanner_bg">
        <NavBar />
        <FilterHeader />
      </div>
      <PropertyListingSection
        heading="Buy Properties"
        request={{ endpoint: "sale/lease/property/list", body: { saleOrLease: "1" } }}
        viewAllHref="/property-filters/for-sale_1"
      />
      <ListingSecondBanner />
      <PropertyListingSection
        heading="Selling Properties"
        request={{ endpoint: "sale/lease/property/list", body: { saleOrLease: "5" } }}
        viewAllHref="/property-filters/sold_5"
      />
      <PropertyListingSection
        heading="House & Lands"
        request={{ endpoint: "category/properties/list", body: { category_id: 1 } }}
        viewAllHref="/property-filters/residential-home-sales_1"
      />
      <NeedHelp />
      <Footer />
    </>
  );
};

export default Propertylisting;
